import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import swal from "sweetalert";

import cross from "../assets/cross.svg";
import arrow from "../assets/arrow.svg";
import plus from "../assets/plus.svg";
import Select from "react-select";
import mockData from "../Components/Table/TABLE_MOCK.json";
import * as actionTypes from "../redux/actionTypes";
import { Key } from "@mui/icons-material";
import { addFilterLineItems, fetchConventionalMode } from "../redux/actions/TemplateTabs/actionCM";
import makeAnimated from "react-select/animated";



import { customStyles } from "../Bookclosure/Components/AddTaskModal";
import commoncss from "../myfin_v2/css/common.module.css";
import buttoncss from "../myfin_v2/css/button.module.css";
import Modal from "../myfin_v2/elements/Modal";
import { Button } from "../myfin_v2/elements/Button";
import { ReactComponent as CloseIcon } from "../myfin_v2/assets/icons/close.svg";
import { ReactComponent as CalenderIcon } from "../myfin_v2/assets/icons/calender.svg";
import { ReactComponent as CloseGreyIcon } from "../myfin_v2/assets/icons/close_grey.svg";
import InputGroup from "../myfin_v2/elements/InputGroup";
import bookclosure_taskstatus from "../myfin_v2/data/bookclosure_taskstatus.json";
import modules from "../myfin_v2/data/modules.json";
// import FilterRow from "./FilterRow";
import CustomDropdownIndicator from "../myfin_v2/elements/CustomDropdownIndicator";


const animatedComponents = makeAnimated();

const popupCustomStyles = {
  control: (provided, state) => ({
    ...provided,
    backgroundColor: '#f4faf5',
    borderColor: '#c2e6d1',
    color: '#b3c0bd',
    boxShadow: state.isFocused ? '0 0 0 1px #c2e6d1' : 'none',
    borderWidth: '1px',
    borderRadius: '10px',
    '&:hover': {
      borderColor: '#b3c0bd',
    },
    minHeight: '32px',
    height: '32px',
    display: 'flex',
    alignItems: 'center',
  }),
  valueContainer: (provided) => ({
    ...provided,
    padding: '0px 8px',
    display: 'flex',
    alignItems: 'center',
    height: '30px',
  }),
  input: (provided) => ({
    ...provided,
    color: '#4d6d64',
    margin: '0px',
    padding: '0px',
    fontSize: '12px',
  }),
  placeholder: (provided) => ({
    ...provided,
    color: '#b3c0bd',
    fontSize: '12px',
    marginTop: '0px',
    padding: '0px',
  }),
  singleValue: (provided) => ({
    ...provided,
    color: '#4d6d64',
    fontSize: '12px',
    marginTop: '0px',
    padding: '0px',
  }),
  indicatorsContainer: (provided) => ({
    ...provided,
    height: '30px',
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    color: '#1A4338',
    marginTop: '0px',
    padding: '4px',
    ':hover': {
      color: '#1A4338',
    },
  }),
  clearIndicator: (provided) => ({
    ...provided,
    color: '#b3c0bd',
    ':hover': {
      color: '#4f665f',
    },
  }),
  menu: (provided) => ({
    ...provided,
    backgroundColor: '#ffffff',
    border: '1px solid #c2e6d1',
    borderRadius: '6px',
    boxShadow: '0 4px 6px rgba(0,0,0,0.05)',
    marginTop: '4px',
    zIndex: 9999,
  }),
  menuList: (provided) => ({
    ...provided,
    padding: '4px',
    borderRadius: '6px',
    maxHeight: '140px', // Show 4 or 5 options with scroll
    overflowY: 'auto',
  }),
  menuPortal: (provided) => ({
    ...provided,
    zIndex: 9999,
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected
      ? '#f4faf5'
      : state.isFocused
        ? '#f8f9f9'
        : 'transparent',
    color: '#4f665f',
    padding: '6px 10px',
    cursor: 'pointer',
    fontSize: '12px', // Reduce size of text inside dropdown
    borderRadius: '6px',
    marginBottom: '4px', // some gap between each active and hover text
    display: 'flex',
    alignItems: 'center',
    textAlign: 'left',
    ':last-child': {
      marginBottom: '0px',
    },
  }),
  noOptionsMessage: (provided) => ({
    ...provided,
    color: '#b3c0bd',
    padding: '8px 12px',
  }),
};

const popup = {
  position: "Fixed",
  minHeight: "10rem",
  minWidth: "10rem",
  width: "66%",
  zIndex: "10",
  backgroundColor: "#F1F2F5",
  top: "3.5rem",
  left: "5%",
  borderRadius: "8px",
  boxShadow: "4px 6px 8px 0px #C0C0C060",
  padding: "20px",
  transform: "scale(0.9)",
  // maxHeight:'20rem',
  // overflowX: 'hidden',
  // overflowY: 'scroll',
};
const flexContainer = {
  display: "flex",
  // justifyContent:'center',
  alignItems: "center",
};
const close = {
  height: "43px",
  width: "43px",
  backgroundColor: "white",
  display: "flex",
  justifyContent: "center",
  alignItem: "center",
  borderRadius: "6px",
  fontWeight: "normal",
  marginRight: "15px",
};
const noClose = {
  height: "43px",
  width: "43px",
  backgroundColor: "#cacacabf",
  display: "flex",
  justifyContent: "center",
  alignItem: "center",
  borderRadius: "6px",
  fontWeight: "normal",
  marginRight: "15px",
};
const field = {
  width: "25%",
  marginRight: "15px",
};
const contains = {
  width: "20%",
  marginRight: "15px",
};
const inputs = {
  width: "33%",
  marginRight: "15px",
};
const input = {
  height: "46px",
  border: "1px solid #cacacabf",
  padding: "10px",
  borderRadius: "6px",

  ":focusVisible": {
    outline: "none",
    border: "2px solid #03565A",
  },
};

const search = {
  width: "85px",
  height: "46px",
  backgroundColor: "#03565A",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  borderRadius: "6px",
};
const noSearch = {
  width: "46px",
  height: "46px",
  backgroundColor: "#03565a98",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  borderRadius: "6px",
};

const addFilter = {
  marginTop: "1rem",
  color: "#03565A",
  fontSize: "1.1rem",
  fontWeight: "600",
  display: "flex",
  alignItems: "center",
};

const text = {
  fontWeight: "500",
  fontSize: "1rem",
  color: "#696F79",
};

const textBox = {
  marginRight: "15px",
  width: "3rem",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
};

const textBoxAmount = {
  marginRight: "15px",
  width: "3rem",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  marginTop: "7px",
};

const initialState = {
  startAmount: "",
  endAmount: "",
};
const columnName = [
  { value: "ledger_code", label: "LEDGER CODE" },
  { value: "ledger_name", label: "LEDGER NAME" },
  // { value: 'branch', label: 'BRANCH' },
  // { value: 'PREVIOUS YEAR', label: 'PREVIOUS YEAR' },
  { value: "net_adjusted_amount", label: "FINAL AMT" },
  { value: "cy", label: "CURRENT AMT" },
  { value: "py", label: "PREVIOUS AMT" },
  { value: "adjusted_amount", label: "ADJUSTMENT AMT" },

  // { value: 'FS GROUPING', label: 'FS GROUPING' },
  // { value: 'NOTES GROUPING', label: 'NOTES GROUPING' },
  // { value: 'SUB GROUPING', label: 'SUB GROUPING' },
];
// const opte = ['ledger_code', 'ledger_name',]
const type = [
  { value: "Contains", label: "Contains" },
  { value: "is empty", label: "Is empty" },
];

const finalAmountOptions = [
  { value: "Less than", label: "Less than" },
  { value: "Greater than", label: "Greater than" },
  { value: "Equal to", label: "Equal to" },
];

export default function Filter({
  show,
  setObject,
  setFilterShow,
  filterRow,
  setFilterRow,
  handleApplyFilter,
  SetConfirmFilClose,
  filterHandler,
  filterEnable
}) {
  const dispatch = useDispatch();
  const [data, setData] = useState(mockData);
  const [state, setstate] = useState([
    // { column: "", select: "", change: "", startAmount: "", endAmount: "" },
  ]);
  const [find, setFind] = useState({ column: "", select: "", change: "" });
  const [tempFiltered, setTempFiltered] = useState({});
  const [render, setRender] = useState("");
  const tableData = useSelector(
    (initialState) => initialState.reducer.tableData
  );
  const filter = useSelector((initialState) => initialState.reducer.filter);
  const { response, filterData } = useSelector((state) => state.ConventionModeReducer);
  const [value, setValue] = useState(initialState);

  useEffect(() => {
    if (show) {
      if (filter && filter.length > 0) {
        setstate(filter);
      } else if (state.length === 0) {
        handleNew();
      }
    }
  }, [show]);

  const [isFilter, setFilter] = useState(false);

  // useEffect(() => {
  //   console.log(find, "find");
  // }, [find]);

  // useEffect(() => {
  //   const initData = data;
  //   setstate(filter);
  // }, []);

  function applyFilters(data, filters) {
    return data.filter(item => {
      let includeItem = true;
      filters.forEach(filter => {
        const { column, select, change, startAmount } = filter;
        if (select === "Contains") {
          if (item[column] && !item[column].toLowerCase().includes(change.toLowerCase())) {
            includeItem = false;
          }
        } else if (select === "is empty") {
          if (item[column] && item[column] !== "") {
            includeItem = false;
          }
        } else if (select === "Less than") {
          if (item[column] && !(item[column] < parseInt(startAmount))) {
            includeItem = false;
          }
        } else if (select === "Greater than") {
          if (item[column] && !(item[column] > parseInt(startAmount))) {
            includeItem = false;
          }
        } else if (select === "Equal to") {
          if (!(item[column] === parseInt(startAmount))) {
            includeItem = false;
          }
        }
      });
      return includeItem;
    });
  }

  const handleFilter = () => {
    const project_id = localStorage.getItem("project_id");
    const tb_id = localStorage.getItem("tb_id");

    const mappedFilters = state
      .filter(f => f.column && f.select)
      .map(f => {
        let operator = "contains";
        if (f.select === "Contains") operator = "contains";
        else if (f.select === "is empty") operator = "isEmpty";
        else if (f.select === "Less than") operator = "lessThan";
        else if (f.select === "Greater than") operator = "greaterThan";
        else if (f.select === "Equal to") operator = "equalTo";

        let value = "";
        if (f.column === "ledger_code" || f.column === "ledger_name") {
          value = f.change;
        } else {
          value = f.startAmount !== "" ? Number(f.startAmount) : "";
        }

        return {
          field: f.column,
          operator,
          value
        };
      });

    const rowsPerPage = response?.pagination?.limit || 100;
    const filtersToPass = mappedFilters.length > 0 ? mappedFilters : null;

    dispatch({ type: actionTypes.SET_FILTER, payload: state });
    dispatch(fetchConventionalMode(project_id, tb_id, 1, rowsPerPage, filtersToPass));
    filterHandler(false);
    setFilterShow(false);
  };

  const handleChange = (field, i, e) => {
    let search = state;

    if (
      field === "change" ||
      field === "startAmount" ||
      field === "endAmount"
    ) {
      let search = state;
      search[i][field] = e.target.value;
      setstate(search);
      setRender(Math.random());
    } else {
      let temp = state;
      temp[i][field] = e.value;
      if (field === "select" && e.value === "is empty") {
        temp[i]["change"] = "";
      }
      setstate(temp);
      setRender(Math.random());
    }
  };
  useEffect(() => {
    setObject(state);
    setRender(Math.random());
  }, [state]);

  function handleDelete(i) {
    const temp = state;

    const newarr = temp.filter((val, ix) => ix !== i);
    setstate(newarr);
    dispatch({ type: actionTypes.SET_FILTER, payload: newarr });
    setFilter(newarr.length > 0);
    
    const project_id = localStorage.getItem("project_id");
    const tb_id = localStorage.getItem("tb_id");
    const rowsPerPage = response?.pagination?.limit || 100;
    
    if (newarr.length === 0) {
      setFilterShow(false);
      filterHandler(false);
      dispatch(fetchConventionalMode(project_id, tb_id, 1, rowsPerPage, null));
    } else {
      const mappedFilters = newarr
        .filter(f => f.column && f.select)
        .map(f => {
          let operator = "contains";
          if (f.select === "Contains") operator = "contains";
          else if (f.select === "is empty") operator = "isEmpty";
          else if (f.select === "Less than") operator = "lessThan";
          else if (f.select === "Greater than") operator = "greaterThan";
          else if (f.select === "Equal to") operator = "equalTo";

          let value = "";
          if (f.column === "ledger_code" || f.column === "ledger_name") {
            value = f.change;
          } else {
            value = f.startAmount !== "" ? Number(f.startAmount) : "";
          }

          return {
            field: f.column,
            operator,
            value
          };
        });
      const filtersToPass = mappedFilters.length > 0 ? mappedFilters : null;
      dispatch(fetchConventionalMode(project_id, tb_id, 1, rowsPerPage, filtersToPass));
    }
    
    swal({
      title: "Success",
      text: "Filter removed",
      icon: "success",
      timer: 2000,
      buttons: false
    });
  }

  function handleNew() {
    setstate((oldArray) => [
      ...oldArray,
      { column: "", select: "", change: "", startAmount: "", endAmount: "" },
    ]);
    setFilter(true);
  }

  if (!show) return null;
  return (
    <>

      <Modal
        width={`38%`}
        minHeight={"350px"}
        title="Custom Filters"
        // bodycss={commoncss.unsetPadding}
        headerActions={
          <>
            {state.length > 0 && (
              <label
                className={`${commoncss.textLabel} ${commoncss.fs15} ${commoncss.clickable}`}
                onClick={() => { 
                  setstate([]); 
                  dispatch({ type: actionTypes.SET_FILTER, payload: [] });
                }}
              >
                Reset All
              </label>
            )}
          </>
        }
        onClose={() => console.log("Modal Closed")}
        footerActions={
          <>
            <Button
              btnColor={buttoncss.secondary}
              onClick={() => {
                setFilterShow(false);
                filterHandler(false);
              }}
              label="Cancel"
            />
            <span>
              <Button
                btnColor={buttoncss.secondary}
                label="Add Filter"
                onClick={() => {
                  handleNew();
                }}
              />
              &ensp;
              {state.length > 0 ? (
                <Button
                  btnColor={buttoncss.primary}
                  label="Apply Filter"
                  onClick={handleFilter}
                />
              ) : (

                <Button
                  btnColor={buttoncss.primary}
                  label="Apply Filter"
                  onClick={handleFilter}
                />
              )}
            </span>
          </>
        }
      >
        {state.map((val, i) => {
          const last = state.length - 1;
          const istrue = true;
          return (
            <>
              <span className="input-label mt-1">&nbsp;Where</span>
              <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <Select
                    placeholder="Select Field"
                    value={columnName.filter(function (option) {
                      return option.value === val.column;
                    })}
                    options={columnName}
                    onChange={(e) => handleChange("column", i, e)}
                    className="w-100 mt-0"
                    classNamePrefix="select"
                    components={{
                      ...animatedComponents,
                      IndicatorSeparator: () => null,
                      DropdownIndicator: CustomDropdownIndicator,
                    }}
                    styles={popupCustomStyles}
                    menuPortalTarget={document.body}
                  />
                </div>

                <div style={{ flex: 1, minWidth: 0 }}>
                  {val.column === "ledger_name" || val.column === "ledger_code" ? (
                    <Select
                      placeholder="Select Type"
                      value={type.filter(function (option) {
                        return option.value === val.select;
                      })}
                      //   {state[i].select}
                      options={type}
                      onChange={(e) => handleChange("select", i, e)}
                      className="w-100 mt-0"
                      classNamePrefix="select"
                      components={{
                        ...animatedComponents,
                        IndicatorSeparator: () => null,
                        DropdownIndicator: CustomDropdownIndicator,
                      }}
                      styles={popupCustomStyles}
                      menuPortalTarget={document.body}
                    />
                  ) : (
                    <Select
                      placeholder="Select Type"
                      value={finalAmountOptions.filter(function (option) {
                        return option.value === val.select;
                      })}
                      //   {state[i].select}
                      options={finalAmountOptions}
                      onChange={(e) => handleChange("select", i, e)}
                      className="w-100 mt-0"
                      classNamePrefix="select"
                      components={{
                        ...animatedComponents,
                        IndicatorSeparator: () => null,
                        DropdownIndicator: CustomDropdownIndicator,
                      }}
                      styles={popupCustomStyles}
                      menuPortalTarget={document.body}
                    />
                  )}
                </div>

                <div style={{ flex: 1, minWidth: 0 }}>
                  <InputGroup
                    inputs={[
                      <input
                        style={{
                          height: "32px",
                          padding: "0 10px",
                          fontSize: "12px",
                          border: "1px solid #c2e6d1",
                          backgroundColor: "#f4faf5",
                          borderRadius: "10px",
                          color: "#4d6d64",
                          boxSizing: "border-box",
                          width: "100%",
                          textAlign: "left",
                          outline: "none",
                        }}
                        placeholder="Enter value"
                        value={(val.column === "ledger_code" || val.column === "ledger_name") ? val.change : val.startAmount}
                        disabled={val.select === "is empty"}
                        onChange={(e) => {
                          if (val.column === "ledger_code" || val.column === "ledger_name") {
                            handleChange("change", i, e);
                          } else {
                            handleChange("startAmount", i, e);
                          }
                        }}
                      />,
                    ]}
                  />
                </div>
                <button
                  onClick={() => {
                    handleDelete(i);
                  }}
                  style={{
                    background: "transparent",
                    border: "none",
                    fontSize: "1.2rem",
                    cursor: "pointer",
                    alignSelf: "baseline",
                  }}
                  title="Remove filter"
                >
                  <CloseGreyIcon />
                </button>
              </div>
            </>
          );
        })}
      </Modal>
    </>
  );
}
